import {ICityMetaInfo, IHotelData} from '../../SRP/redux/types';

export interface ICommonStoreState {
  destination: ICityVoyagerObj;
  checkin: ICheckinCheckoutDate;
  checkout: ICheckinCheckoutDate;
  roomString: string;
  country: string;
  partner: string;
  // ! this can be spliced off into separate reducer
  segmentSliderApi: {
    isLoading: boolean;
    data: ISegmentSliderData;
    error?: string | boolean;
  };
  metaPartner: string;
}

export interface ICityVoyagerObj {
  n: string;
  _id: string;
  t?: string;
  xtr?: {
    cc: string;
    flt?: {
      loc: {_id: string; n: string};
    };
  };
  ct?: {
    _id: string;
    n: string;
  };
  crd?: Array<number>;
}

export interface ICheckinCheckoutDate {
  date: Date;
  isMidnight?: boolean;
}

export interface ISegmentSliderData {
  data_list: Array<ISegmentSliderDataItem>;
  city_meta_info: ICityMetaInfo;
}

export interface ISegmentSliderDataItem {
  data: Array<IHotelData>;
  banner_data: {t: string; mbg?: Array<string>; img?: string};
}

export const UPDATE_QUERY = 'UPDATE_QUERY';
export const TOGGLE_LOADING_SEGMENT_SLIDER = 'TOGGLE_LOADING_SEGMENT_SLIDER';
export const ERROR_LOADING_SEGMENT_SLIDER = 'ERROR_LOADING_SEGMENT_SLIDER';
export const UPDATE_SEGMENT_SLIDER_DATA = 'UPDATE_SEGMENT_SLIDER_DATA';
export const RESET_SEGMENT_SLIDER = 'RESET_SEGMENT_SLIDER';

export interface IUpdate_Query {
  type: typeof UPDATE_QUERY;
  actionData: Pick<ICommonStoreState, 'destination'> &
    Pick<ICommonStoreState, 'checkin'> &
    Pick<ICommonStoreState, 'checkout'> &
    Pick<ICommonStoreState, 'roomString'> &
    Pick<ICommonStoreState, 'partner'> &
    Pick<ICommonStoreState, 'country'> &
    Pick<ICommonStoreState, 'metaPartner'>;
}

export interface IToggleLoadingSegmentSlider {
  type: typeof TOGGLE_LOADING_SEGMENT_SLIDER;
  actionData: ICommonStoreState['segmentSliderApi']['isLoading'];
}

export interface IErrorLoadingSegmentSlider {
  type: typeof ERROR_LOADING_SEGMENT_SLIDER;
  actionData: ICommonStoreState['segmentSliderApi']['error'];
}

export interface IUpdateSegmentSlider {
  type: typeof UPDATE_SEGMENT_SLIDER_DATA;
  actionData: ICommonStoreState['segmentSliderApi']['data'];
}

export interface IResetSegmentSliderData {
  type: typeof RESET_SEGMENT_SLIDER;
}

export type CommonActionTypes =
  | IUpdate_Query
  | IToggleLoadingSegmentSlider
  | IUpdateSegmentSlider
  | IResetSegmentSliderData
  | IErrorLoadingSegmentSlider;
